import React, { useEffect } from 'react'

//Import Images
import img1 from "../../../assets/images/Frame 51.png"
import playstore from "../../../assets/images/Frame 53.png"
import appstore from "../../../assets/images/Frame 54.png"

//Import AOS
import AOS from "aos";
import "aos/dist/aos.css";


function Downloadfromplaystore() {
  useEffect(() => {
      AOS.init({
        duration: 1000, // Animation duration in milliseconds
        once: false,
        offset: 100,  // Trigger when the element is 100px from the viewport
    delay: 200, // Whether animation should happen only once
      });
    }, []);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center md:mt-16 xl:mt-20">
      <div
        className="col-span-3 py-16 px-4 flex flex-col justify-between h-full md:pl-10"
        data-aos="fade-right" >
        <h2 className="text-2xl md:text-4xl xl:text-5xl font-bold text-[#214293] mb-4 oxygen">
          Download Our Application
        </h2>
        <p className="text-[#868686] lg:text-lg md:max-w-[85%] oxygen">
          Our trusted partners are esteemed organizations and individuals who collaborate with us to deliver exceptional value and ensure the highest quality in our services and solutions.
        </p>
        <h1 className='text-xl md:text-2xl lg:text-3xl text-[#565656] font-medium pt-4 oxygen'>
          Download App From
        </h1>
        <div className='flex justify-start items-center flex-col sm:flex-row gap-6 pt-4'>
          <img src={playstore} alt="" className='h-16 md:h-20'/>
          <img src={appstore} alt="" className='h-16 md:h-20'/>
        </div>
      </div>

      
        <img
          alt="Live"
          src={img1}
          className="col-span-2 mx-auto w-[85%]  hover:scale-105 transform transition-transform duration-300"
          data-aos="fade-left" />
    </div>
  )
}

export default Downloadfromplaystore;


